// Biology Unit Tests and Exercises - Years 11-13
// Based on Vanuatu National Syllabus

// Year 11 Biology Unit Tests
export const year11BiologyUnitTests = {
  term1: {
    title: "Term 1 - Cellular Biology & Genetics",
    tests: [
      {
        title: "Unit Test 1: Cell Structure",
        duration: "45 minutes",
        totalMarks: 50,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Short Answer", marks: 20, questions: 5 },
          { name: "Section C: Extended Response", marks: 15, questions: 2 }
        ],
        sampleQuestions: [
          "Draw and label a typical animal cell showing at least 6 organelles",
          "Compare and contrast plant and animal cells",
          "Explain the function of the mitochondria in cellular respiration"
        ]
      },
      {
        title: "Unit Test 2: Cell Transport",
        duration: "45 minutes",
        totalMarks: 50,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Definitions and Diagrams", marks: 20, questions: 5 },
          { name: "Section C: Problem Solving", marks: 15, questions: 2 }
        ],
        sampleQuestions: [
          "Define diffusion, osmosis, and active transport",
          "Describe what happens to a red blood cell placed in distilled water",
          "Explain the relationship between surface area to volume ratio and cell size"
        ]
      },
      {
        title: "Unit Test 3: Enzymes",
        duration: "45 minutes",
        totalMarks: 50,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Graph Analysis", marks: 20, questions: 5 },
          { name: "Section C: Experimental Design", marks: 15, questions: 2 }
        ],
        sampleQuestions: [
          "Explain the induced fit model of enzyme action",
          "Describe how temperature affects enzyme activity with reference to a graph",
          "Compare competitive and non-competitive inhibitors"
        ]
      }
    ]
  },
  term2: {
    title: "Term 2 - Genetics & Organism Level Biology",
    tests: [
      {
        title: "Unit Test 4: Molecular Genetics",
        duration: "45 minutes",
        totalMarks: 50,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: DNA Structure and Function", marks: 20, questions: 5 },
          { name: "Section C: Protein Synthesis", marks: 15, questions: 2 }
        ],
        sampleQuestions: [
          "Describe the structure of a DNA nucleotide",
          "Explain the base pairing rules in DNA and RNA",
          "Compare and contrast transcription and translation"
        ]
      },
      {
        title: "Unit Test 5: Cell Division",
        duration: "45 minutes",
        totalMarks: 50,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Diagrams and Labelling", marks: 20, questions: 5 },
          { name: "Section C: Comparison Essay", marks: 15, questions: 2 }
        ],
        sampleQuestions: [
          "Draw and label the stages of mitosis",
          "Explain why DNA replication is described as semi-conservative",
          "Compare mitosis and meiosis in terms of purpose, products, and genetic variation"
        ]
      },
      {
        title: "Unit Test 6: Plant Reproduction",
        duration: "45 minutes",
        totalMarks: 50,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Life Cycles", marks: 20, questions: 5 },
          { name: "Section C: Essay", marks: 15, questions: 2 }
        ],
        sampleQuestions: [
          "Compare sexual and asexual reproduction in plants",
          "Draw and label the life cycle of a fern showing alternation of generations",
          "Explain why mosses need water for reproduction"
        ]
      }
    ]
  },
  term3: {
    title: "Term 3 - Environmental Biology & Evolution",
    tests: [
      {
        title: "Unit Test 7: Nutrition and Digestion",
        duration: "45 minutes",
        totalMarks: 50,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Digestive System", marks: 20, questions: 5 },
          { name: "Section C: Diet Analysis", marks: 15, questions: 2 }
        ],
        sampleQuestions: [
          "Compare traditional and modern Pacific diets",
          "List the digestive enzymes and their locations of action",
          "Explain the role of bile in fat digestion"
        ]
      },
      {
        title: "Unit Test 8: Ecosystems and Classification",
        duration: "45 minutes",
        totalMarks: 50,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Food Web Analysis", marks: 20, questions: 5 },
          { name: "Section C: Classification", marks: 15, questions: 2 }
        ],
        sampleQuestions: [
          "Draw a food web for a local Vanuatu ecosystem",
          "Explain why energy decreases at each trophic level",
          "List the seven levels of classification in order"
        ]
      },
      {
        title: "Unit Test 9: Natural Selection",
        duration: "45 minutes",
        totalMarks: 50,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Darwin's Theory", marks: 20, questions: 5 },
          { name: "Section C: Evidence Analysis", marks: 15, questions: 2 }
        ],
        sampleQuestions: [
          "Describe the five main points of Darwin's theory of natural selection",
          "Compare natural selection and artificial selection",
          "Explain adaptive radiation using Darwin's finches as an example"
        ]
      }
    ]
  },
  practicalAssessments: [
    {
      title: "Practical 1: Microscopy Skills",
      duration: "60 minutes",
      marks: 30,
      skills: ["Preparing wet mounts", "Calculating cell size", "Drawing scientific diagrams"]
    },
    {
      title: "Practical 2: Osmosis Investigation",
      duration: "90 minutes",
      marks: 30,
      skills: ["Experimental design", "Data collection", "Graph construction"]
    },
    {
      title: "Practical 3: Enzyme Activity",
      duration: "60 minutes",
      marks: 30,
      skills: ["Controlling variables", "Temperature effects", "Rate calculation"]
    },
    {
      title: "Practical 4: Ecosystem Investigation",
      duration: "Field trip + 60 min write-up",
      marks: 30,
      skills: ["Field sampling", "Data analysis", "Species identification"]
    }
  ]
};

// Year 12 Biology Unit Tests
export const year12BiologyUnitTests = {
  term1: {
    title: "Term 1 - Cellular Processes",
    tests: [
      {
        title: "Unit Test 1: Cellular Respiration",
        duration: "50 minutes",
        totalMarks: 60,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Short Answer", marks: 25, questions: 5 },
          { name: "Section C: Extended Response", marks: 20, questions: 2 }
        ],
        sampleQuestions: [
          "Describe the three stages of aerobic respiration and where each occurs",
          "Compare aerobic and anaerobic respiration in terms of ATP yield",
          "Explain the role of oxygen in the electron transport chain"
        ]
      },
      {
        title: "Unit Test 2: Photosynthesis",
        duration: "50 minutes",
        totalMarks: 60,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Diagram and Explanation", marks: 25, questions: 5 },
          { name: "Section C: Graph Analysis", marks: 20, questions: 2 }
        ],
        sampleQuestions: [
          "Draw and label a chloroplast showing where light and dark reactions occur",
          "Explain how limiting factors affect the rate of photosynthesis",
          "Compare the products of light-dependent and light-independent reactions"
        ]
      },
      {
        title: "Unit Test 3: Cellular Immunity",
        duration: "50 minutes",
        totalMarks: 60,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Immune Response", marks: 25, questions: 5 },
          { name: "Section C: Vaccination Essay", marks: 20, questions: 2 }
        ],
        sampleQuestions: [
          "Describe the roles of B lymphocytes and T lymphocytes in immune response",
          "Explain how antibodies protect the body from pathogens",
          "Discuss the importance of vaccination programs in disease prevention"
        ]
      }
    ]
  },
  term2: {
    title: "Term 2 - Genetics & Organism Systems",
    tests: [
      {
        title: "Unit Test 4: Mendelian Inheritance",
        duration: "50 minutes",
        totalMarks: 60,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Punnett Squares", marks: 25, questions: 5 },
          { name: "Section C: Genetic Problems", marks: 20, questions: 2 }
        ],
        sampleQuestions: [
          "Complete a dihybrid cross and determine the expected phenotype ratio",
          "Explain the difference between incomplete dominance and codominance",
          "Solve a genetics problem involving multiple alleles (blood type)"
        ]
      },
      {
        title: "Unit Test 5: Plant and Animal Structure",
        duration: "50 minutes",
        totalMarks: 60,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Comparative Anatomy", marks: 25, questions: 5 },
          { name: "Section C: Circulatory System Essay", marks: 20, questions: 2 }
        ],
        sampleQuestions: [
          "Compare leaf structure in different plant types",
          "Explain why mammals have a four-chambered heart",
          "Compare single and double circulation in animals"
        ]
      },
      {
        title: "Unit Test 6: Excretion and Nervous System",
        duration: "50 minutes",
        totalMarks: 60,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Organ Systems", marks: 25, questions: 5 },
          { name: "Section C: Homeostasis Essay", marks: 20, questions: 2 }
        ],
        sampleQuestions: [
          "Describe the structure and function of a nephron",
          "Explain how nerve impulses are transmitted across a synapse",
          "Discuss how the nervous and excretory systems maintain homeostasis"
        ]
      }
    ]
  },
  term3: {
    title: "Term 3 - Ecology & Evolution",
    tests: [
      {
        title: "Unit Test 7: Population Ecology",
        duration: "50 minutes",
        totalMarks: 60,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Growth Curves", marks: 25, questions: 5 },
          { name: "Section C: Population Analysis", marks: 20, questions: 2 }
        ],
        sampleQuestions: [
          "Compare J-shaped and S-shaped population growth curves",
          "Explain the concept of carrying capacity",
          "Distinguish between density-dependent and density-independent factors"
        ]
      },
      {
        title: "Unit Test 8: Communities and Interactions",
        duration: "50 minutes",
        totalMarks: 60,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Species Interactions", marks: 25, questions: 5 },
          { name: "Section C: Succession Essay", marks: 20, questions: 2 }
        ],
        sampleQuestions: [
          "Compare predator-prey, parasitism, and mutualism relationships",
          "Explain the role of pioneer species in ecological succession",
          "Describe zonation and stratification patterns in communities"
        ]
      },
      {
        title: "Unit Test 9: Evolution Patterns",
        duration: "50 minutes",
        totalMarks: 60,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Evolution Types", marks: 25, questions: 5 },
          { name: "Section C: Speciation Essay", marks: 20, questions: 2 }
        ],
        sampleQuestions: [
          "Compare divergent and convergent evolution with examples",
          "Explain allopatric and sympatric speciation",
          "Describe pre-zygotic and post-zygotic isolating mechanisms"
        ]
      }
    ]
  },
  practicalAssessments: [
    {
      title: "Practical 1: Respiration Rate Investigation",
      duration: "90 minutes",
      marks: 40,
      skills: ["Respirometer use", "Data collection", "Statistical analysis"]
    },
    {
      title: "Practical 2: Photosynthesis Investigation",
      duration: "90 minutes",
      marks: 40,
      skills: ["Controlling variables", "Measuring gas production", "Graph analysis"]
    },
    {
      title: "Practical 3: Population Sampling",
      duration: "Field trip + 60 min write-up",
      marks: 40,
      skills: ["Quadrat sampling", "Mark-recapture technique", "Population estimation"]
    }
  ]
};

// Year 13 Biology Unit Tests
export const year13BiologyUnitTests = {
  term1: {
    title: "Term 1 - Molecular Biology & Genetics",
    tests: [
      {
        title: "Unit Test 1: DNA Replication",
        duration: "60 minutes",
        totalMarks: 70,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Replication Mechanism", marks: 30, questions: 6 },
          { name: "Section C: Extended Response", marks: 25, questions: 2 }
        ],
        sampleQuestions: [
          "Explain why DNA replication is called semi-conservative",
          "Describe the role of helicase, DNA polymerase, and ligase in replication",
          "Explain the formation and significance of Okazaki fragments"
        ]
      },
      {
        title: "Unit Test 2: Protein Synthesis",
        duration: "60 minutes",
        totalMarks: 70,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Process Description", marks: 30, questions: 6 },
          { name: "Section C: Code Translation", marks: 25, questions: 2 }
        ],
        sampleQuestions: [
          "Describe the four levels of protein structure",
          "Explain the features of the genetic code",
          "Translate an mRNA sequence into an amino acid sequence using a codon table"
        ]
      },
      {
        title: "Unit Test 3: Gene Interactions",
        duration: "60 minutes",
        totalMarks: 70,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Genetic Problems", marks: 30, questions: 6 },
          { name: "Section C: Essay", marks: 25, questions: 2 }
        ],
        sampleQuestions: [
          "Explain epistasis with reference to modified phenotype ratios",
          "Describe the inheritance pattern for X-linked recessive traits",
          "Solve a problem involving sex-linked inheritance (color blindness)"
        ]
      }
    ]
  },
  term2: {
    title: "Term 2 - Biotechnology & Animal Behaviour",
    tests: [
      {
        title: "Unit Test 4: Biotechnology",
        duration: "60 minutes",
        totalMarks: 70,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Techniques", marks: 30, questions: 6 },
          { name: "Section C: Applications", marks: 25, questions: 2 }
        ],
        sampleQuestions: [
          "Describe the steps of PCR and explain its importance",
          "Explain how gel electrophoresis separates DNA fragments",
          "Discuss the applications and ethical implications of genetic engineering"
        ]
      },
      {
        title: "Unit Test 5: Animal Behaviour",
        duration: "60 minutes",
        totalMarks: 70,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Behaviour Types", marks: 30, questions: 6 },
          { name: "Section C: Navigation Essay", marks: 25, questions: 2 }
        ],
        sampleQuestions: [
          "Compare innate and learned behaviour with examples",
          "Explain the difference between taxes and kinesis",
          "Describe how animals use different methods for navigation and migration"
        ]
      },
      {
        title: "Unit Test 6: Biological Rhythms and Competition",
        duration: "60 minutes",
        totalMarks: 70,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Rhythms and Interactions", marks: 30, questions: 6 },
          { name: "Section C: Essay", marks: 25, questions: 2 }
        ],
        sampleQuestions: [
          "Explain the difference between circadian and circannual rhythms",
          "Describe interspecific and intraspecific competition",
          "Discuss how territory establishment increases survival chances"
        ]
      }
    ]
  },
  term3: {
    title: "Term 3 - Climate Change & Evolution",
    tests: [
      {
        title: "Unit Test 7: Climate Change",
        duration: "60 minutes",
        totalMarks: 70,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Causes and Effects", marks: 30, questions: 6 },
          { name: "Section C: Pacific Islands Essay", marks: 25, questions: 2 }
        ],
        sampleQuestions: [
          "Explain the enhanced greenhouse effect",
          "Describe five impacts of climate change on Pacific Island nations",
          "Compare adaptation and mitigation strategies for addressing climate change"
        ]
      },
      {
        title: "Unit Test 8: Variation and Gene Pools",
        duration: "60 minutes",
        totalMarks: 70,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Sources of Variation", marks: 30, questions: 6 },
          { name: "Section C: Genetic Drift Essay", marks: 25, questions: 2 }
        ],
        sampleQuestions: [
          "Explain how meiosis creates genetic variation",
          "Compare the founder effect and bottleneck effect",
          "Discuss how genetic drift affects allele frequency in small populations"
        ]
      },
      {
        title: "Unit Test 9: Speciation and Evolution Patterns",
        duration: "60 minutes",
        totalMarks: 70,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Speciation Mechanisms", marks: 30, questions: 6 },
          { name: "Section C: Evolution Essay", marks: 25, questions: 2 }
        ],
        sampleQuestions: [
          "Compare allopatric and sympatric speciation with examples",
          "Describe pre-zygotic and post-zygotic isolating mechanisms",
          "Explain divergent, convergent, and co-evolution with specific examples"
        ]
      }
    ]
  },
  internalAssessments: [
    {
      title: "IA Task 1: Genetics Investigation",
      duration: "Ongoing project",
      marks: 10,
      strand: 2,
      description: "Design and conduct a genetics investigation, collect data, and write a scientific report"
    },
    {
      title: "IA Task 2: Organism Level Biology Research",
      duration: "Research project",
      marks: 15,
      strand: 3,
      description: "Research an animal's ecological niche, including habitat, adaptations, and behavior"
    },
    {
      title: "IA Task 3: Environmental Biology Project",
      duration: "Field study + report",
      marks: 15,
      strand: 4,
      description: "Investigate climate change impacts on a local ecosystem and propose conservation strategies"
    }
  ],
  practicalAssessments: [
    {
      title: "Practical 1: DNA Extraction",
      duration: "60 minutes",
      marks: 30,
      skills: ["DNA extraction protocol", "Laboratory techniques", "Scientific writing"]
    },
    {
      title: "Practical 2: Animal Behaviour Study",
      duration: "90 minutes + analysis",
      marks: 30,
      skills: ["Behavioural observation", "Data collection", "Statistical analysis"]
    },
    {
      title: "Practical 3: Ecological Investigation",
      duration: "Field trip + write-up",
      marks: 30,
      skills: ["Field sampling", "Species identification", "Environmental monitoring"]
    }
  ]
};

export default {
  year11BiologyUnitTests,
  year12BiologyUnitTests,
  year13BiologyUnitTests
};
